/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import { isArrayNotEmpty } from "utils/empty-exists";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { useAuth } from "cms/auth/hooks/use-auth";
import { EntityContext } from "../../context";

const SelectEntityAttributeEditor = (props) => {
    
    const name = props.name;
    const value = props.value;
    const { token } = useAuth();

    const [selected, setSelected] = useState(value);

    const entityContext = useContext(EntityContext);
    const schema = entityContext?.schema;
    const attributes = schema?.attributes;
    const attr = attributes?.find((attribute) => attribute.key === name);
    const key = attr?.list;
    const updateAttribute = entityContext?.updateAttribute;

    const onChangeSelection = (event) => {
        const _selected = event.target.value;
        setSelected(_selected);
        updateAttribute(name, _selected);
    };

    const initialList = ["Loading..."];
    const [list, setList] = useState(initialList);

    useEffect(() => {
        const load = async () => {
            if (!list || list[0] === "Loading..." && key) {
                console.info("load List", key);
                const _list = await SimpliCityAdminSDK.list.findOneByKey(token, key);
                _list.map((item) => ({ key: item, value: item }));
                setList(_list);
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
    
    return (
        <Fragment>
            <div className="entity-attribute-editor-label">
                {name}
            </div>
            <div className="entity-attribute-editor-panel">
                {isArrayNotEmpty(list) &&
                    <FormControl style={{ marginTop: "3px", marginBottom: "3px", width: "100%" }} size="small">
                        <Select
                            labelId='document-select'
                            id='document-style-select'
                            value={selected}
                            fullWidth={true}
                            variant='outlined'
                            onChange={(event) => onChangeSelection(event)}
                        >
                            {selected === "" &&
                                <MenuItem value=''>Select...</MenuItem>
                            }
                            {list.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                }
            </div>
        </Fragment>
    );
};

export { SelectEntityAttributeEditor };
